import React from 'react';
import { RegisterForm } from '../../components/auth';

export const RegisterPage: React.FC = () => {
  return <RegisterForm />;
};